/**
 * Front-end slider behaviour for the Testimonials block.
 *
 * Shows a single testimonial at a time and lets visitors page through them
 * with the previous / next arrows. The list wraps around at both ends.
 */
document.addEventListener( 'DOMContentLoaded', function () {
	const sliders = document.querySelectorAll( '[data-testimonials-slider]' );

	sliders.forEach( function ( slider ) {
		const slides = Array.prototype.slice.call(
			slider.querySelectorAll( '[data-testimonials-slide]' )
		);

		if ( slides.length === 0 ) {
			return;
		}

		const prev = slider.querySelector( '[data-testimonials-prev]' );
		const next = slider.querySelector( '[data-testimonials-next]' );

		let current = slides.findIndex( function ( slide ) {
			return slide.classList.contains( 'is-active' );
		} );

		if ( current < 0 ) {
			current = 0;
		}

		const show = function ( index ) {
			current = ( index + slides.length ) % slides.length;
			slides.forEach( function ( slide, i ) {
				slide.classList.toggle( 'is-active', i === current );
			} );
		};

		// Hide the arrows when there is nothing to navigate to.
		if ( slides.length < 2 ) {
			if ( prev ) {
				prev.hidden = true;
			}
			if ( next ) {
				next.hidden = true;
			}
		}

		if ( prev ) {
			prev.addEventListener( 'click', function () {
				show( current - 1 );
			} );
		}

		if ( next ) {
			next.addEventListener( 'click', function () {
				show( current + 1 );
			} );
		}

		show( current );
	} );
} );
